//resend otp
export const RESEND_OTP_REQUEST = "RESEND_OTP_REQUEST";
export const RESEND_OTP_RECEIVE = "RESEND_OTP_RECEIVE";
export const RESEND_OTP_FAILURE = "RESEND_OTP_FAILURE";
export const RESET_RESEND_OTP= "RESET_RESEND_OTP";